import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { GoogleReviewStatusInterface, PromotionCodeResponseInterface } from '../exports/Interfaces';
import ReduxActions from '../../store/ReduxActions';
import { actionCreators } from '../../store/actions';

class PromotionManager {
  public getPromoCodes = async (companyId: number): Promise<DataWrappedResponse<PromotionCodeResponseInterface>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/promo-codes`,
    });

    const { success, response } = request;

    if (success) {
      ReduxActions.dispatch(
        actionCreators.initialData.updateCompany({
          promo_codes: response.data.data,
        }),
      );
    }

    return request;
  };

  public async getGoogleReviewStatus(companyId: number): Promise<DataWrappedResponse<GoogleReviewStatusInterface>> {
    if (typeof companyId !== 'number') {
      return {
        response: null,
        success: false,
        status: 400,
      };
    }

    return BackendApiClient.requestAuthorized({
      method: 'GET',
      url: `/companies/${companyId}/last-google-review`,
    });
  }

  public async uploadGoogleReview(
    companyId: number,
    data: FormData,
    onUploadProgress: (progressPercentage: number) => void,
  ) {
    return BackendApiClient.requestAuthorized({
      method: 'POST',
      url: `/companies/${companyId}/google-reviews`,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onUploadProgress(percentCompleted);
      },
    });
  }
}

export default new PromotionManager();
